import Swal from "sweetalert2";
export const handleCouponEdit = async (couponData,{fetchData, editingCoupon, setEditingCoupon, cars, rentals, coupons, contact, drivers, tours, tourBookings, employeeService, setCarsData, setRentalsData, setCouponsData, setTransfersData, setDriversData, setToursData, setTourBookingsData, setEmployeesData, setSeasonalPricing, setIsLoading, setError}) => {
  try {
    await coupons.update(editingCoupon._id, couponData);
    setEditingCoupon(null);
    fetchData();
    await Swal.fire({
      icon: "success",
      title: "Success",
      text: "Coupon updated successfully!",
      confirmButtonColor: "#1e3a8a",
    });
  } catch (error) {
    console.error("Error updating coupon:", error);
    await Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to update coupon. Please try again.",
      confirmButtonColor: "#1e3a8a",
    });
  }
};